"use strict";
import DataStoreService from "../accounts_payable/data_store_service";
import ApiService from "../services/api_service";
export const CARRIER_INVOICE_MODEL_OBJECT_TYPE = "carrier";
export const FACTOR_INVOICE_MODEL_OBJECT_TYPE = "factor";
export const LOAD_SHIPMENT_MODEL_OBJECT_TYPE = "load_shipment";
export default {
  create: function(invoiceId, invoiceType, message) {
    var data = { message };
    return ApiService.addErrorHandler(
      $.post(this.createEndpoint(invoiceType, invoiceId), data).then(DataStoreService.responseHandler, _.identity)
    );
  },
  resolve: function(invoiceId, invoiceType, message, exception) {
    return ApiService.addErrorHandler(
      $.post(this.resolveEndpoint(
        invoiceType,
        invoiceId,
        exception.id
      ), { resolution: message }).then(function(data) {
        DataStoreService.updateStores(data);
        return data;
      })
    );
  },
  createEndpoint: function(invoiceType, id) {
    const endpoint = this.getEndpoint(invoiceType);
    return "/api/" + endpoint + "/" + id + "/exceptions/";
  },
  resolveEndpoint: function(invoiceType, invoiceId, exceptionId) {
    const endpoint = this.getEndpoint(invoiceType);
    return "/api/" + endpoint + "/" + invoiceId + "/exceptions/" + exceptionId + "/resolve";
  },
  getEndpoint: function(invoiceType) {
    if (invoiceType === FACTOR_INVOICE_MODEL_OBJECT_TYPE) {
      return "factor_invoices";
    } else if (invoiceType === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
      return "load_shipments";
    } else {
      return "carrier_invoices";
    }
  }
};
